import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/Global.css"; // Globala stilar
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log performance metrics (valfritt, kan kommenteras bort)
reportWebVitals();